interface DraftingExchangeReturn {
  pendingReturnItems: readonly {
    variantExchangeItem?: unknown;
    exchangeGroup?: unknown;
    advancedExchangeItems?: readonly unknown[] | null;
  }[];
  newOrderData?: { items: readonly unknown[] } | null;
}

export function isDraftingExchangeReturn(
  draftReturn: DraftingExchangeReturn,
): boolean {
  return (
    draftReturn.pendingReturnItems.some(
      (item) =>
        !!item.variantExchangeItem ||
        !!item.exchangeGroup ||
        (item.advancedExchangeItems?.length ?? 0) > 0,
    ) || (draftReturn.newOrderData?.items.length ?? 0) > 0
  );
}
